import { useQueryClient } from 'react-query';
import {
  CONSUMER_CMS_SHOPPING_CART,
  getProductCategory,
  IProduct,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import {
  API,
  getClickToCall,
  IClickToCallConfigurations,
  IClickToCallConfigurationsCMS,
} from '@vfit/shared/data-access';
import React, { useEffect, useState } from 'react';
import { Accordion, Button, CheckboxList } from '@vfit/shared/atoms';
import {
  getCtcByKey,
  getCtcKey,
  getErrorsKeys,
  getProductByKey,
  getProductKey,
} from './clickToCallTestConfigurations.utils';
import SearchElement from '../SearchElement/searchElement';
import { FaqContainer } from './clickToCallTestConfigurations.style';
import { ICMSApiError, ICMSError } from '@vfit/shared/models';

const ClickToCallConfigurations = () => {
  const GLOBAL_OPTIONS = [
    { id: 'fixed', value: 'iBuy fixed' },
    { id: 'mobile', value: 'iBuy mobile' },
  ];
  const client = useQueryClient();
  const shoppingCartProducts = client?.getQueryData(['shopping-cart-products']);
  const products: IProduct[] = shoppingCartProducts
    ? Object.values(shoppingCartProducts) || []
    : [];
  const iBuyFixedCustomerErrors = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_CUSTOMER_ERROR_FIXED
  ) as ICMSApiError;
  const iBuyMobileCustomerErrors = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_CUSTOMER_ERROR_MOBILE
  ) as ICMSApiError;
  const iBuyFixedErrors = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_ORDER_ERROR
  ) as ICMSApiError;
  const iBuyMobileRecurrentErrors = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_RECURRENT_ORDER_ERROR_MOBILE
  ) as ICMSApiError;
  const iBuyMobileInstantErrors = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_INSTANT_ORDER_ERROR_MOBILE
  ) as ICMSApiError;
  const iBuyFixedClickToCallConfigurations = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_CLICK_TO_CALL_FIXED_CONFIGURATIONS
  ) as IClickToCallConfigurationsCMS;
  const iBuyMobileClickToCallConfigurations = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_CLICK_TO_CALL_MOBILE_CONFIGURATIONS
  ) as IClickToCallConfigurationsCMS;

  const productsListItems = products?.map((p) => getProductKey(p));
  const mockFixedProduct = products?.find(
    (el) => getProductCategory(el?.offerType || '') === 'fixed'
  );
  const mockMobileProduct = products?.find(
    (el) => getProductCategory(el?.offerType || '') === 'mobile'
  );
  const iBuyFixedCustomerErrorsListItems = iBuyFixedCustomerErrors?.errorcomponent?.errors?.filter(
    (e) => e.isClickToCall === 'true' && !!e.keyClickToCall
  );
  const iBuyMobileustomerErrorsListItems = iBuyMobileCustomerErrors?.errorcomponent?.errors?.filter(
    (e) => e.isClickToCall === 'true' && !!e.keyClickToCall
  );
  const iBuyFixedOrderErrorsListItems = iBuyFixedErrors?.errorcomponent?.errors?.filter(
    (e) => e.isClickToCall === 'true' && !!e.keyClickToCall
  );
  const iBuyMobileRecurrentErrorsListItems =
    iBuyMobileRecurrentErrors?.errorcomponent?.errors?.filter(
      (e) => e.isClickToCall === 'true' && !!e.keyClickToCall
    );
  const iBuyMobileInstantErrorsListItems = iBuyMobileInstantErrors?.errorcomponent?.errors?.filter(
    (e) => e.isClickToCall === 'true' && !!e.keyClickToCall
  );
  const ctcGlobalFixedListItems =
    iBuyFixedClickToCallConfigurations?.clicktocallconfigura?.elements?.map((p) =>
      getCtcKey(p, true, 'fixed')
    );
  const ctcGlobalMobileListItems =
    iBuyMobileClickToCallConfigurations?.clicktocallconfigura?.elements?.map((p) =>
      getCtcKey(p, true, 'mobile')
    );

  const [isInResetMode, setIsInResetMode] = useState<boolean>(false);
  const [showConfiguration, setShowConfiguration] = useState<boolean>(false);
  const [selectedGlobalOptions, setSelectedGlobalOptions] = useState<string>('fixed');
  const [selectedProductInDropdown, setSelectedProductInDropdown] = useState<string>('');
  const [selectedProduct, setSelectedProduct] = useState<IProduct | undefined>(undefined);
  const [selectedCtcInDropdown, setSelectedCtcInDropdown] = useState<string>('');
  const [selectedCtc, setSelectedCtc] = useState<IClickToCallConfigurations | undefined>(undefined);
  const [showConfigurationCustomer, setShowConfigurationCustomer] = useState<boolean>(false);
  const [selectedCtcCustomer, setSelectedCtcCustomer] = useState<
    IClickToCallConfigurations | undefined
  >(undefined);
  // region Handle OnChange (Move also this in other f.)

  const handleSelectProduct = (selectedProduct: React.ChangeEvent<HTMLInputElement>) =>
    setSelectedProductInDropdown(selectedProduct?.target?.value || '');

  const handleSelectCtcProduct = (selectedCtcProduct: React.ChangeEvent<HTMLInputElement>) =>
    setSelectedCtcInDropdown(selectedCtcProduct?.target?.value || '');

  const handleSelectCtcError = (selectedCtcError: React.ChangeEvent<HTMLInputElement>) => {
    const value = selectedCtcError?.target?.value || '';
    const ctcKey = value?.split('Ctc:')?.[1]?.trim();
    if (ctcKey) {
      const isFixedLine = selectedGlobalOptions === 'fixed';
      const errorCtc = isFixedLine
        ? iBuyFixedClickToCallConfigurations?.clicktocallconfigura?.elements?.find(
            (e) => e.key === ctcKey
          )
        : iBuyMobileClickToCallConfigurations?.clicktocallconfigura?.elements?.find(
            (e) => e.key === ctcKey
          );
      if (errorCtc) {
        setSelectedCtc(errorCtc);
      }
    }
  };

  const handleSelectCtcErrorCustomer = (selectedCtcError: React.ChangeEvent<HTMLInputElement>) => {
    const value = selectedCtcError?.target?.value || '';
    const ctcKey = value?.split('Ctc:')?.[1]?.trim();
    if (ctcKey) {
      const isFixedLine = selectedGlobalOptions === 'fixed';
      const errorCtc = isFixedLine
        ? iBuyFixedClickToCallConfigurations?.clicktocallconfigura?.elements?.find(
            (e) => e.key === ctcKey
          )
        : iBuyMobileClickToCallConfigurations?.clicktocallconfigura?.elements?.find(
            (e) => e.key === ctcKey
          );

      if (errorCtc) {
        setSelectedCtcCustomer(errorCtc);
      }
    }
  };

  // endregion

  const getProductCtcList = (): string[] => {
    const productCtcKeys = (selectedProduct?.clicktocallconfigura?.elements || [])?.map((p) =>
      getCtcKey(p)
    );
    const isFixedLine = selectedProduct
      ? getProductCategory(selectedProduct?.offerType || '') === 'fixed'
      : selectedGlobalOptions === 'fixed';
    const globalList = isFixedLine ? ctcGlobalFixedListItems : ctcGlobalMobileListItems;
    return [...productCtcKeys, ...globalList];
  };

  const getErrorsList = (): string[] => {
    const isFixedLine = selectedGlobalOptions === 'fixed';
    const iBuyFixedKeyList = getErrorsKeys(iBuyFixedOrderErrorsListItems);
    const iBuyMobileRecurrentKeyList = getErrorsKeys(iBuyMobileRecurrentErrorsListItems);
    const iBuyMobileInstantKeyList = getErrorsKeys(iBuyMobileInstantErrorsListItems);
    const errorKeyList = isFixedLine
      ? iBuyFixedKeyList
      : [...iBuyMobileRecurrentKeyList, ...iBuyMobileInstantKeyList];
    return errorKeyList;
  };

  const getErrorsCustomerList = (): string[] => {
    const isFixedLine = selectedGlobalOptions === 'fixed';
    const iBuyFixedKeyList = getErrorsKeys(iBuyFixedCustomerErrorsListItems);
    const iBuyMobileKeyList = getErrorsKeys(iBuyMobileustomerErrorsListItems);
    const errorKeyList = isFixedLine ? iBuyFixedKeyList : iBuyMobileKeyList;
    return errorKeyList;
  };

  // region Renders (move in other comp.)

  const getCTCForProduct = () => {
    return (
      <SearchElement
        title={'Seleziona una configurazione Click To Call'}
        labelSelect={'Click to call'}
        selectedProductItem={selectedCtcInDropdown}
        productsListItems={getProductCtcList()}
        handleSelectProduct={handleSelectCtcProduct}
        submitVariant={'secondary'}
        clearable
      />
    );
  };

  const getCTCForErrors = () => {
    return (
      <SearchElement
        title={'Seleziona una configurazione di errore'}
        labelSelect={'Configurazione errore'}
        selectedProductItem={selectedCtcInDropdown}
        productsListItems={getErrorsList()}
        handleSelectProduct={handleSelectCtcError}
        submitVariant={'secondary'}
        clearable
      />
    );
  };

  const getCTCForErrorsCustomer = () => {
    return (
      <SearchElement
        title={'Seleziona una configurazione di errore generico sul customer'}
        labelSelect={'Configurazione errore'}
        selectedProductItem={selectedCtcCustomer?.key}
        productsListItems={getErrorsCustomerList()}
        handleSelectProduct={handleSelectCtcErrorCustomer}
        submitVariant={'secondary'}
        clearable
      />
    );
  };

  const getActionsForCTC = () => {
    if (isInResetMode) return <></>;
    return (
      <div
        style={{
          margin: '0 25px',
          marginTop: 50,
        }}
      >
        <Button
          onClick={() =>
            getClickToCall(client, {
              idClickToCall: selectedCtc?.key,
              product: selectedProduct,
            })
          }
          style={{
            marginBottom: 20,
          }}
        >
          Vedi Click To Call
        </Button>
        <Button onClick={() => setShowConfiguration(true)}>Vedi Configurazione</Button>
        {showConfiguration && (
          <div style={{ marginTop: 50 }}>
            <pre>{JSON.stringify(selectedCtc, null, 2)}</pre>;
          </div>
        )}
      </div>
    );
  };

  const getActionsForCTCCustomer = () => {
    if (isInResetMode) return <></>;
    return (
      <div
        style={{
          margin: '0 25px',
          marginTop: 50,
        }}
      >
        <Button
          onClick={() =>
            getClickToCall(client, {
              idClickToCall: selectedCtcCustomer?.key,
              product: selectedGlobalOptions === 'fixed' ? mockFixedProduct : mockMobileProduct,
            })
          }
          style={{
            marginBottom: 20,
          }}
        >
          Vedi Click To Call
        </Button>
        <Button onClick={() => setShowConfigurationCustomer(true)}>Vedi Configurazione</Button>
        {showConfigurationCustomer && (
          <div style={{ marginTop: 50 }}>
            <pre>{JSON.stringify(selectedCtcCustomer, null, 2)}</pre>;
          </div>
        )}
      </div>
    );
  };

  const renderGlobalCTC = () => {
    if (isInResetMode) return <></>;
    return (
      <div
        style={{
          width: '100%',
          marginBottom: 200,
        }}
      >
        <div
          style={{
            marginTop: 50,
          }}
        >
          <CheckboxList
            passedValueIndex={0}
            onChangeItem={(e) => setSelectedGlobalOptions(e?.value || '')}
            items={GLOBAL_OPTIONS?.map((e) => ({
              title: e.value || '',
              value: e.id || '',
            }))}
          />
        </div>
        {getCTCForProduct()}
        {selectedCtc && getActionsForCTC()}
      </div>
    );
  };

  const renderProductsCTC = () => {
    if (isInResetMode) return <></>;
    return (
      <div
        style={{
          width: '100%',
          marginBottom: 200,
        }}
      >
        <SearchElement
          title={'Seleziona un prodotto'}
          labelSelect={'Prodotto'}
          selectedProductItem={selectedProductInDropdown}
          productsListItems={productsListItems}
          handleSelectProduct={handleSelectProduct}
          submitVariant={'secondary'}
          clearable
        />
        {selectedProduct && getCTCForProduct()}
        {selectedCtc && getActionsForCTC()}
      </div>
    );
  };

  const renderErrorsCTC = () => {
    if (isInResetMode) return <></>;
    return (
      <div
        style={{
          width: '100%',
          marginBottom: 200,
        }}
      >
        <div
          style={{
            marginTop: 50,
          }}
        >
          <CheckboxList
            passedValueIndex={0}
            onChangeItem={(e) => setSelectedGlobalOptions(e?.value || '')}
            items={GLOBAL_OPTIONS?.map((e) => ({
              title: e.value || '',
              value: e.id || '',
            }))}
          />
          <p>
            Per iBuy fixed gli errori recuperati sono quelli di <b>/common/order-errors</b>
          </p>
          <p>
            Per iBuy mobile gli errori recuperati sono quelli di{' '}
            <b>/common/order-recurrent-errors</b> e <b>/common/order-instant-errors</b>
          </p>
        </div>
        {getCTCForErrors()}
        {selectedCtc && getActionsForCTC()}
      </div>
    );
  };

  const renderErrorsCustomerCTC = () => {
    if (isInResetMode) return <></>;
    return (
      <div
        style={{
          width: '100%',
          marginBottom: 200,
        }}
      >
        <div
          style={{
            marginTop: 50,
          }}
        >
          <CheckboxList
            passedValueIndex={0}
            onChangeItem={(e) => setSelectedGlobalOptions(e?.value || '')}
            items={GLOBAL_OPTIONS?.map((e) => ({
              title: e.value || '',
              value: e.id || '',
            }))}
          />
          <p>
            Per iBuy fixed gli errori recuperati sono quelli di <b>/common/customer-errors</b>
          </p>
          <p>
            Per iBuy mobile gli errori recuperati sono quelli di sono quelli di{' '}
            <b> /common/customer-errors</b>
          </p>
        </div>
        {getCTCForErrorsCustomer()}
        {selectedCtcCustomer && getActionsForCTCCustomer()}
      </div>
    );
  };

  // endregion

  const resetData = () => {
    setSelectedGlobalOptions('fixed');
    setSelectedProductInDropdown('');
    setSelectedProduct(undefined);
    setSelectedCtcInDropdown('');
    setShowConfiguration(false);
    setSelectedCtc(undefined);
    setIsInResetMode(false);
  };

  useEffect(() => {
    setShowConfiguration(false);
  }, [selectedCtc]);

  useEffect(() => {
    setSelectedProduct(getProductByKey(selectedProductInDropdown, products));
  }, [selectedProductInDropdown]);

  useEffect(() => {
    setSelectedCtc(
      getCtcByKey(
        selectedCtcInDropdown,
        iBuyFixedClickToCallConfigurations,
        iBuyMobileClickToCallConfigurations,
        selectedProduct
      )
    );
  }, [selectedCtcInDropdown]);

  useEffect(() => {
    if (isInResetMode) {
      resetData();
    }
  }, [isInResetMode]);

  return (
    <>
      <div>
        <FaqContainer>
          <div
            style={{
              marginTop: 20,
              marginBottom: 50,
            }}
          >
            <h2>Scegli la configurazione Click to call</h2>
            <p>La prima sezione è per testare le configurazioni globali</p>
            <p>
              La seconda sezione è per testare le configurazioni di prodotto. Se non esistono
              configurazioni per il prodotto scelto, verranno visualizzate le configurazioni globali
              per quella tipologia di prodotto
            </p>
          </div>
          <Accordion
            title={'Configurazioni globali - Fixed/Mobile'}
            iconColor="#e60000"
            iconSize={24}
            content={[renderGlobalCTC()]}
            onShowing={() => setIsInResetMode(true)}
          />
          <Accordion
            title={'Configurazione per prodotto'}
            iconColor="#e60000"
            iconSize={24}
            content={[renderProductsCTC()]}
            onShowing={() => setIsInResetMode(true)}
          />
          <Accordion
            title={'Configurazione degli errori di pagamento - Fixed/Mobile'}
            iconColor="#e60000"
            iconSize={24}
            content={[renderErrorsCTC()]}
            onShowing={() => setIsInResetMode(true)}
          />
          <Accordion
            title={'Configurazione degli errori generici - Fixed/Mobile'}
            iconColor="#e60000"
            iconSize={24}
            content={[renderErrorsCustomerCTC()]}
            onShowing={() => setIsInResetMode(true)}
          />
        </FaqContainer>
      </div>
    </>
  );
};

export default ClickToCallConfigurations;

